import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {UserActions} from '../user/user.actions';
import {UserModel} from '../user/user.model';
import {AuthorizationUtils} from '../utils/authorization.utils';

@Injectable({
  providedIn: 'root'
})
export class PartnerGuardService implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(): boolean | UrlTree {
    const user: UserModel = UserActions.userGetLocalStorage();


    if (AuthorizationUtils.isAdmin(user) && !user.partnerId) {
      return this.router.parseUrl('/partner');
    }

    return true;
  }
}
